const getDeviceTimezone = () => {
  const DateTimeFormat = Intl?.DateTimeFormat;
  if (!DateTimeFormat) return 'UTC';

  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export default getDeviceTimezone;
